<h4 class="title">Old Follow up Trails</h4>
<!-- <h4 class="title">Follow Up Trails</h4> -->
<div class="row">
    <!-- <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div> -->
    <div class="col-md-5">
        <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
    </div>
    <!-- <div class="col-md-2 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
    </div> -->
  </div>
  
  
  
  <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
  
          <ng-template pTemplate="header">
              <tr class="thhead">
                  <th class="th-1">
                      S.No
                  </th>
                  <th>
                     Loan No
                  </th>
                  <th>
                     Product
                  </th>
                  <th>
                    Bucket
                </th>
                <th>
                 Action Date
              </th>
              <th>
                Action Time
            </th>
            <th>
             Contact Mode
          </th>
          <th>
           Place Contacted
         </th>
         <th>
         Person Contacted
       </th>
       <th>
        Action Code
     </th>
     <th>
      Action Amount
   </th>
   <th>
    Remarks
  </th>
  <th>
    Review Date
  </th>
  <th>
    Review Time
  </th>
  <th>
    Contacted By
  </th>
  <th>
    PTP Status
  </th>
  
                  <!-- <th>
                      Year of completion
                  </th>
                  <th>Experience </th>
                  <th>Specialization </th>
                  <th>Pets handled</th>
                  <th>Clinic address</th>
                  <th>Certificate</th>
                  <th>Govt ID proof </th>
                  <th>Photo ID proof</th>
                  <th>Created by</th>
                  <th>Modified by</th>
                  <th>Created at</th>
                  <th>Modified at</th> -->
                  <th style="width: 110px;text-align:center">
                      Action
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="tdrow">
                  <td>{{i+1}}</td>
                  <td>Record not yet called</td>
                  <td>Active</td>
                  <td>Emirates Islamic Bank Cards</td>
                  <td>Loans</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <td>Champion</td>
                  <!-- <td>Lorem ipsum.</td>
                  <td>Lorem ipsum.</td>
                  <td>Lorem ipsum.</td>
                  <td>Lorem ipsum.</td>
                  <td>Lorem ipsum.</td>
  
                  <td>Lorem ipsum.</td> -->
                  <!-- <td class="act"><i class="fa fa-file-text" style="background-color: #fff;color: #fd2c3a;"
                          aria-hidden="true"></i></td>
                  <td class="act"><i class="fa fa-file-text" style="background-color: #fff;color: #fd2c3a;"
                          aria-hidden="true"></i></td>
                  <td class="act"><i class="fa fa-file-text" style="background-color: #fff;color: #fd2c3a;"
                          aria-hidden="true"></i></td> -->
                  <!-- <td>7373387504</td> -->
                  <!-- <td>
                      User
                  </td>
                  <td>
                      Admin
                  </td>
                  <td>
                      16-09-2020
                  </td>
                  <td>
                      17-09-2020
                  </td> -->
                  <td class="act">
                      <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                      <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                      <!-- <i style="color: #4CAF50;" class="fa fa-info-circle" aria-hidden="true" pTooltip="View"></i> -->
                  </td>
              </tr>
          </ng-template>
       </p-table>  </div>
  
  </div>
  
  
  <br>